export const RecipientType = Object.freeze({
  CANDIDATE: 'candidate',
  CONTACT: 'contact',
})
